import { DocType } from '@/types/Documentation';

export enum AppRoutes {
  HOME = '/',
  DOCUMENTATION = '/documentation',
  DOCUMENTATION_ARTIFACT = '/documentation/[IntroArtifactUUID]?type=[type]',
  DOCUMENTATION_ARTIFACT_DETAIL = '/documentation/[IntroArtifactUUID]/[artifactUUID]?type=[type]',
  SIGNUP = '/signup',
  LOGIN = '/login',
  TEAM_INSIGHTS_SETUP = '/teaminsights-setup',
  PERFORMANCE_REVIEW = '/individual-insights',
  SETTINGS = '/settings',
}

export const getDocumentationArtifactRoute = (
  introArtifactUUID: string,
  type?: string
) => {
  return AppRoutes.DOCUMENTATION_ARTIFACT.replace(
    '[IntroArtifactUUID]',
    introArtifactUUID
  ).replace('[type]', type ?? DocType.TECH_DOCS);
};

export const getDocumentationArtifactDetailRoute = (
  introArtifactUUID: string,
  artifactUUID: string,
  type?: string
) => {
  return AppRoutes.DOCUMENTATION_ARTIFACT_DETAIL.replace(
    '[IntroArtifactUUID]',
    introArtifactUUID
  )
    .replace('[artifactUUID]', artifactUUID)
    .replace('[type]', type ?? DocType.TECH_DOCS);
};

const getPerformanceReviewRoute = (teamUUID: string) => {
  return (
    AppRoutes.PERFORMANCE_REVIEW + (teamUUID ? `?TeamUUID=${teamUUID}` : '')
  );
};

export const getRoute = (route: AppRoutes) => {
  return route;
};

export const getSignUpRoute = ({
  callbackURLAfterSignUp,
  signup,
  extensionName,
  loading,
  cli,
  cliRedirect,
  cliState,
}: {
  callbackURLAfterSignUp?: string;
  signup?: string;
  extensionName?: string;
  loading?: string;
  cli?: string;
  cliRedirect?: string;
  cliState?: string;
}) => {
  const params = new URLSearchParams();
  if (callbackURLAfterSignUp)
    params.set(
      'callbackURLAfterSignUp',
      callbackURLAfterSignUp.replace('//', '/')
    );
  if (signup) params.set('signup', signup);
  if (extensionName) params.set('extensionName', extensionName);
  if (loading) params.set('loading', loading);
  if (cli) params.set('cli', cli);
  if (cliRedirect) params.set('cli_redirect', cliRedirect);
  if (cliState) params.set('cli_state', cliState);
  const queryString = params.toString();
  return queryString ? `${AppRoutes.SIGNUP}?${queryString}` : AppRoutes.SIGNUP;
};

export const getLoginRoute = ({
  callbackURL,
  extensionName,
  signup,
  cli,
  cliRedirect,
  cliState,
}: {
  callbackURL?: string;
  extensionName?: string;
  signup?: string;
  cli?: string;
  cliRedirect?: string;
  cliState?: string;
}) => {
  const params = new URLSearchParams();
  if (callbackURL)
    params.set('callbackURLAfterSignIn', callbackURL.replace('//', '/'));
  if (extensionName) params.set('extensionName', extensionName);
  if (signup) params.set('signup', signup);
  if (cli) params.set('cli', cli);
  if (cliRedirect) params.set('cli_redirect', cliRedirect);
  if (cliState) params.set('cli_state', cliState);
  const queryString = params.toString();
  return queryString ? `${AppRoutes.LOGIN}?${queryString}` : AppRoutes.LOGIN;
};
